<script setup lang="ts">
import BundlesPage from '@/pages/BundlesPage.vue'

import LoadingSpinner from '@/components/LoadingSpinner.vue'
import PageLayout from '@/components/templates/PageLayout.vue'
</script>

<template>
  <PageLayout>
    <Suspense>
      <BundlesPage />
      <template #fallback><LoadingSpinner /></template>
    </Suspense>
  </PageLayout>
</template>
